// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zacian: PokeData = {
  "id": 888,
  "name": "zacian",
  "height": 28,
  "weight": 1100,
  "base_experience": 335,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "swords-dance",
    "bite",
    "quick-attack",
    "slash",
    "metal-claw",
    "crunch",
    "howl",
    "close-combat",
    "giga-impact",
    "iron-head",
    "quick-guard",
    "sacred-sword",
    "noble-roar",
    "moonblast",
    "laser-focus"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "metal-claw",
    "crunch",
    "close-combat",
    "moonblast",
    "play-rough",
    "heal-bell",
    "mist-terrain",
    "spirit-break",
    "moonlight",
    "starfall",
    "hyper-voice"
  ],
  "evolution_chain": {
    "id": 467,
    "item": null,
    "species": [
      {
        "name": "zacian",
        "order": 888,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 115,
    "speed": 153,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
